var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSensorGraphs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 18V15.999H17.998L17.997 18H15ZM2 15.999H5V18H2V15.999ZM18 2L17.999 6.584L16.707 5.292C16.316 4.901 15.684 4.901 15.293 5.292L10 10.585L6.707 7.292C6.316 6.901 5.684 6.901 5.293 7.292L2 10.585V2H18ZM15 9.999V8.413L16 7.413L17.999 9.412V9.999H15ZM15 11.999H17.998V13.999H15V11.999ZM2 13.413L5 10.413V13.999H2V13.413ZM13 18H7V15.999H13V18ZM7 13.999V10.413L9.293 12.706C9.684 13.097 10.316 13.097 10.707 12.706L11.414 11.999H13V13.999H7ZM18 0H2C0.897 0 0 0.897 0 2V18C0 19.103 0.897 20 2 20H18C19.104 20 20 19.103 20 18V2C20 0.897 19.104 0 18 0Z",
    fill: "#7C90B1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorGraphs);
export default __webpack_public_path__ + "static/media/sensorGraphs.cfbb63a8.svg";
export { ForwardRef as ReactComponent };